import React from "react";
import { useAppDispatch, useAppSelector } from "@assets/hooks/redux";
import { Modal } from "@samskip/frontend-components";
import { useTranslation } from "react-i18next";
import CompanyView from "@pages/Company/companyView";
import CompanyEmployeeView from "@pages/Company/companyEmployeeView";
import { closeModal } from "@state/actions";

const CompanyModal: React.FC = () => {
  const { t } = useTranslation();
  const userProfile = useAppSelector((state) => state.UserReducer.userProfile);
  const company = userProfile?.SelectedCompany; // adjust field name
  const userType = userProfile?.Access?.UserType;
  const dispatch = useAppDispatch();

  console.log(userProfile);
  return (
    <Modal title={t("LABEL_COMPANYINFO")} open   closeIcon
      onClose={() => dispatch(closeModal())}
      size="large"
    >
      {userType === "E"
        ? <CompanyEmployeeView company={company} />
        : <CompanyView company={company} />
      }
    </Modal>
  );
};
export default CompanyModal;
